import React, { useCallback } from "react";
import { Form, Row, Col, DatePicker, message } from "antd";
import moment from "moment";
import { confirmPickup } from "@/services/loads";

export default function ConfirmPickupForm({ loadId, formRef, pickupDate, setIsLoadingConfirmPickup, refreshData }) {
  const onSubmit = useCallback(
    values => {
      if (!loadId) return;

      setIsLoadingConfirmPickup(true);

      const payload = {
        date: values.pickup,
      };

      confirmPickup(loadId, payload)
        .then(() => {
          message.success("Pickup confirmed!");
          typeof refreshData === "function" && refreshData();
        })
        .catch(err => {
          console.log(err);
          message.error("Could not confirm pickup");
        })
        .finally(() => {
          setIsLoadingConfirmPickup(false);
        });
    },
    [loadId],
  );

  return (
    <Form
      layout="vertical"
      form={formRef}
      onFinish={onSubmit}
      initialValues={{
        pickup: pickupDate ? moment(pickupDate) : moment(),
      }}
    >
      <Row gutter={16}>
        <Col lg={12}>
          <Form.Item name="pickup" label="Pickup" rules={[{ required: true, message: "Please select a pickup date" }]}>
            <DatePicker format="MM/DD/YYYY h:mm A" showTime={{ format: "HH:mm" }} use12Hours />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
